"use strict";
export let picker;
export  function initDatePicker() {
	console.log('initDatePicker');
	const dateRanges = {
		'Today': [moment(), moment()],
		'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
		'Last 7 Days': [moment().subtract(6, 'days'), moment()],
		'Last 30 Days': [moment().subtract(29, 'days'), moment()],
		'This Month': [moment().startOf('month'), moment().endOf('month')],
		'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
	};
	let storedStartDate = localStorage.getItem('startDate');
	let storedEndDate = localStorage.getItem('endDate');

	let startDate = storedStartDate ? moment(storedStartDate) : moment().subtract(29, 'days');
	let endDate = storedEndDate ? moment(storedEndDate) : moment();

	  $('.input-daterange').daterangepicker({
		startDate: startDate,
		endDate: endDate,
		ranges: dateRanges,
		locale: {
			format: 'YYYY/MM/DD',
			separator: ' - '
		}
	}).on('apply.daterangepicker', function(ev, picker) {
		  localStorage.setItem('startDate', picker.startDate.format('YYYY-MM-DD'));
		  localStorage.setItem('endDate', picker.endDate.format('YYYY-MM-DD'));

		  console.log('apply.daterangepicker');
		  $('#leadsList').DataTable().ajax.reload();
	  }).on('cancel.daterangepicker', function(ev, picker) {
		  localStorage.removeItem('startDate');
		  localStorage.removeItem('endDate');
		  console.log('cancel.daterangepicker');
	});
	  picker = $('.input-daterange').data('daterangepicker');

}
